module.exports = __webpack_public_path__ + "img/resources-768.22efa760.jpg";